import { BrowserRouter, Route, Routes } from "react-router-dom";
import AdminPanel from "./components/admin/AdminPanel";
import CreatorPortfolio from "./components/CreatorPortfolio";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminPanel />} />
        <Route path="*" element={<CreatorPortfolio />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
